module.exports = __webpack_public_path__ + "img/whatsapp.b5b74bd1.svg";